"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.applyAdvertisementFilter = void 0;
var player_base_1 = require("@24i/player-base");
function applyAdvertisementFilter(filter, actual) {
    if (!actual)
        return false;
    if (filter === actual)
        return true;
    if (filter === player_base_1.ITimelineEventPlayed.PLAYING_SKIPPABLE)
        return true;
    if (actual === player_base_1.ITimelineEventPlayed.PLAYING_UNSKIPPABLE)
        return true;
    if (filter === player_base_1.ITimelineEventPlayed.PLAYING_UNSKIPPABLE)
        return false;
    if (actual === player_base_1.ITimelineEventPlayed.PLAYING_SKIPPABLE)
        return false;
    if (filter === player_base_1.ITimelineEventPlayed.PLAYED)
        return true;
    if (actual === player_base_1.ITimelineEventPlayed.UNPLAYED)
        return true;
    return false;
}
exports.applyAdvertisementFilter = applyAdvertisementFilter;
//# sourceMappingURL=applyAdvertisementFilter.js.map